module.exports = __webpack_public_path__ + "static/media/Childhood.93d61a5d.jpg";